module.exports = __webpack_public_path__ + "static/media/lobby-bg.531b2aa1.webp";